import { createURL_SSR, ROUTE } from "app-constants/routing"
import Exhibitor from "components/Exhibitor"
import { ActivityIndicator } from "components/activity-indicator"
import MainLayout from "components/main-layout"
import buildServerSidePage from "lib/build-server-side-page"
import buildServerSideProps from "lib/build-server-side-props"
import { getExhibitorName } from "lib/exhibitors/getExhibitorUtils"
import applyCache from "lib/mw/apply-cache"
import applyCurrentServerContext from "lib/mw/apply-current-server-context"
import applyNextSeo from "lib/mw/apply-next-seo"
import applyRequiredProps from "lib/mw/apply-required-props"
import applyTitle from "lib/mw/apply-title"
import ConventionProviderExhibitor from "models/convention-api/v1/ConventionProviderExhibitor"
import React from "react"

export const getServerSideProps = buildServerSideProps(
  applyCache(),
  applyCurrentServerContext(),
  [
    async (context) => {
      await ConventionProviderExhibitor.applyOne("exhibitor", {
        filter: {
          disabled: "false",
          id: context.params.exhibitor_id as string,
        },
        includes: ["institution", "institution.chatAvailable"],
      })(context)
    },
  ],
  applyRequiredProps("exhibitor"),
  applyTitle(({ props }) => `${props.exhibitor.institution.name}`),
  applyNextSeo((context) => ({
    openGraph: {
      title: `${getExhibitorName(context.props.exhibitor)} - Profile`,
      url: createURL_SSR(context, {
        path: ROUTE.EXHIBITOR,
        params: {
          exhibitorId: context.props.exhibitor.id,
        },
      }),
      type: "website",
      images: [
        {
          url: context.props.exhibitor.cover_photo_url,
          alt: `${getExhibitorName(context.props.exhibitor)} - Profile`,
        },
      ],
    },
  })),
)

interface ExhibitorPageProps {
  exhibitor: ConventionProviderExhibitor
}

export default buildServerSidePage(function ExhibitorPage(props: ExhibitorPageProps) {
  const { exhibitor } = props

  if (!exhibitor) {
    return (
      <MainLayout layout="macro">
        <ActivityIndicator />
      </MainLayout>
    )
  }

  return (
    <MainLayout layout="macro">
      <Exhibitor exhibitor={exhibitor} />
    </MainLayout>
  )
})
